import { useCallback, useMemo } from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { useTranslation } from '@lyearn/i18n';
import { PrinterOutline } from '@lyearn/icons';
import { ActionMenuItemType } from '@lyearn/molecules';

enum QuizEditorActions {
  Export = 'EXPORT',
}

const useQuizExportAction = () => {
  const { t } = useTranslation();
  const [showExportDialog, exportDialogActions] = useToggle(false);

  const menuItems = useMemo<ActionMenuItemType[]>(
    () => [
      {
        id: QuizEditorActions.Export,
        label: t('Common:Actions.Export'),
        EndIcon: PrinterOutline,
      },
    ],
    [t],
  );

  const onMenuItemAction = useCallback(
    (action: string) => {
      if (action === QuizEditorActions.Export) {
        exportDialogActions.on();
      }
    },
    [exportDialogActions],
  );

  return {
    menuItems,
    onMenuItemAction,
    showExportDialog,
    onCloseExportDialog: exportDialogActions.off,
  };
};

export default useQuizExportAction;
